'use strict';

var Utils = require('../utils/utils');
var AppendCaret = require('../append-caret/append-caret');
var CollapseNav = require('../collapse-nav/collapse-nav');
var NavSoftScroll = require('./lib/nav-soft-scroll');

// Constructor
var MainNav = function() {

  var self = this;

  self.config = {

    'mainNav'         :  '.main-nav',

    // Alpha level
    'alphaLevelItem'  :  '.main-nav > ul > li',
    'alphaLevelLink'  :  '.main-nav > ul > li > a',

    // Beta level
    'betaLevel'       :  '.main-nav > ul > li > ul',
    'betaFadeInItem'   :  '.main-nav > ul > li > ul > li > a, .main-nav > ul > li > ul > li > ul > li'
  }

  self.init = function() {

    var collapseConfig = {
      item: self.config.alphaLevelItem,
      link: self.config.alphaLevelLink,
      subnav: self.config.betaLevel,
      subnavItem: self.config.betaFadeInItem
    };

    var largeViewports = function() {
      new CollapseNav(collapseConfig).destroy();
    };

    var smallViewports = function() {
      new CollapseNav(collapseConfig).init();
    };

    new AppendCaret({
      item: self.config.alphaLevelItem,
      link: self.config.alphaLevelLink,
      subnav: self.config.betaLevel
    }).init();

    new Utils().matchmediaHandler('MEDIUM', largeViewports, smallViewports);

    new NavSoftScroll({
      nav: self.config.mainNav
    }).init();
  }
};

module.exports = MainNav;
